import types from "../http_common";
import { apiRequest } from "../authConfig";

async function bearerToken(instance) {
  const account = instance.getActiveAccount();
  if (!account) {
    throw new Error(
      'No active account! Verify a user has been signed in and setActiveAccount has been called.'
    );
  }
  const response = await instance.acquireTokenSilent({
    ...apiRequest,
    account,
  });
  return response.accessToken;
}

/**
 * Generic client for the backend's shared job system
 * (routes/jobs.js -> controller/jobs.js). Any job started via
 * utils/jobStore.js on the backend can be polled/downloaded this way,
 * regardless of what feature started it.
 */
const getJobStatus = async (jobId, instance) => {
  const api = types.json();
  const token = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + token;
  return await api.get(`/jobs/${jobId}/status`);
};

const downloadJob = async (jobId, instance, onDownloadProgress) => {
  const api = types.json();
  const token = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + token;
  return await api.get(`/jobs/${jobId}/download`, {
    responseType: 'blob',
    onDownloadProgress
  });
};

const JobsApiService = {
  getJobStatus,
  downloadJob
};

export default JobsApiService;
